import React, { useEffect, useState } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LabelList, ResponsiveContainer } from 'recharts'
import Spinner from '../Spinner/Spinner'
import './Chart.scss'

export default function Chart({ data, barFill, direction, loaded }) {

    const [chartData, setChartData] = useState([])
    let chartDataArray = [];

    useEffect(() => {
        if (loaded) {
            data.map(entry => {
                if(entry.name !== undefined) {
                    if(entry.exportSTONS !== undefined && entry.exportSTONS !== '0.00') {
                        chartDataArray.push({
                            name: entry.name,
                            value: direction === 'IMPORTS' ? Math.round(entry.importSTONS) : Math.round(entry.exportSTONS)
                        })
                    } else if(entry.importSTONS !== undefined && entry.importSTONS !== '0.00') {
                        chartDataArray.push({
                            name: entry.name,
                            value: direction === 'IMPORTS' ? Math.round(entry.importSTONS) : Math.round(entry.exportSTONS)
                        })
                    }
                } else {
                    if(entry.exportSTONS !== undefined && entry.exportSTONS !== '0.00') {
                        chartDataArray.push({
                            name: entry.name,
                            value: direction === 'IMPORTS' ? Math.round(entry.importSTONS) : Math.round(entry.exportSTONS)
                        })
                    } else if(entry.importSTONS !== undefined && entry.importSTONS !== '0.00') {
                        chartDataArray.push({
                            name: entry.name,
                            value: direction === 'IMPORTS' ? Math.round(entry.importSTONS) : Math.round(entry.exportSTONS)
                        })
                    }
                }
            })
            setChartData(chartDataArray)
        }
    }, [data, loaded])

    return (
        <div className="chart">
            <div className="chart-title">TOP {direction}</div>
            <div className={`chart-container ${chartData.length === 0 ? 'no-commodities-container' : ''}`}>
                {
                    loaded ?
                        (chartData.length !== 0  ? 
                            <>
                                <ResponsiveContainer>
                                    <BarChart width={800}
                                        height={300}
                                        data={chartData}
                                        margin={{ top: 5, left: 5, right: 5, bottom: 5 }}
                                        layout='vertical'
                                    >
                                        <XAxis type="number" />
                                        <YAxis type="category"
                                            dataKey="name"
                                            tickLine={false}
                                            width={150}
                                        />
                                        <Tooltip />
                                        <CartesianGrid stroke="#e8e8e8"
                                            horizontal={false} />
                                        <Legend />
                                        <Bar dataKey="value"
                                            fill={barFill}
                                            name="Tons" >
                                                {/* labels commented out until client feedback */}
                                            {/* <LabelList dataKey="value" position="right" fill="#000" /> */}
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </> 
                        : <p className='no-commodity'>No {direction.toLowerCase().replace("s","")} commodities.</p>)
                        : <Spinner />
                }
            </div>
        </div>
    )
}
